<template>
    <div class="contact">
<!--   <first-Component></first-Component>-->
      <img class="banner animated fadeIn" src="../assets/c.png" alt="" id="d1">
      <div class="link animated fadeInLeft">
        <div class="main">
          <span class="title">{{$t('support.link[0]')}}</span>
          <span> {{$t('support.link[1]')}}</span>
        </div>
      </div>
      <p class="oneTitle wow fadeInUp">{{$t('support.title')}}</p>
      <p class="ia wow fadeInUp" style="font-size: 20px;text-transform: capitalize">{{$t('support.title1')}}</p>
      <div class="three wow fadeInUp">
        <span>
          <i class="iconfont icon-dianhua"></i>
          <p class="bb">{{$t('support.con1[0]')}}</p>
          <p style="font-family: light2">{{$t('support.con1[1]')}}</p>
        </span>
        <span>
          <i class="iconfont icon-weizhi"></i>
          <p class="bb">{{$t('support.con2[0]')}}</p>
          <p style="font-family: light2">{{$t('support.con2[1]')}}<br>
         {{$t('support.con2[2]')}}</p>
        </span>
        <span>
          <i class="iconfont icon-youxiang" style="font-size: 50px;"></i>
          <p class="bb">{{$t('support.con3[0]')}}</p>
          <p style="font-family: light2">{{$t('support.con3[1]')}}<br>
           {{$t('support.con3[2]')}}
                        </p>
        </span>

      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import firstComponent from  "./first"
  import footComponent from "./foot"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
    export default {
        name: "contact",
      mounted(){
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
      },
      components:{firstComponent,footComponent,BtnComponent},
      methods:{
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
      }
    }
</script>

<style scoped>
.contact{
  width:100%;
}
.banner{
   width:100%;
   display: block;
 }
.link{
  width:100%;
  padding: 30px 0;
  border-bottom: 1px solid rgba(250, 250, 250, 1);
}
.link .main{
  width:1280px;
  margin: 0 auto;
  text-align: left;
}
.link .main span{
  color:#C9382C;
  text-transform: uppercase;
}
.link .main .title{
  color:black;
}
.oneTitle{
  text-align: center;
  font-weight: bold;
  font-size: 25px;
  text-transform: uppercase;
  margin-top: 60px;
  position: relative;
  width:30%;
  margin-left: 35%;
  padding-bottom: 20px;
}
.oneTitle::before{
  content: '';
  display: inline-block;
  width:10%;
  left:45%;
  bottom:0;
  height:2px;
  position: absolute;
  background-color: #C9382C;
}
.ia{
  margin-top: 50px;
}
  .three{
    width:1280px;
    margin:100px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .three span{
    display:inline-block;
    width:25%;
  }
  i{
    display: inline-block;
    height:111px;
    width:111px;
    background-color: rgba(201, 56, 44, 1);
    border-radius: 50%;
    font-size: 50px;
    line-height: 111px;
    color:white;
  }
  .three span p{
    line-height: 30px;
  }
  .bb{
    font-size: 25px;
    font-weight: bold;
  }
@media screen and (max-width:450px){
  .banner{
    height:100vh;
    object-fit: cover;
  }
  .contact{
    overflow: hidden;
  }
  .link .main{
    width:90%;
    margin-left: 5%;
  }
  .ia{
    line-height: 30px;
    width:95%;
    margin-left: 2.5%;
    font-size: 16px !important;
  }
  .three{
    width:100%;
    display: flex;
    flex-direction: column;
  }
  .three span{
    width:100%;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue